const PROJECT_ELEMENT = 'ITWBMPR0'
const CODE_ELEMENTS = ['PROJCODE2', 'ProjCode2']
const NAME_ELEMENTS = ['PROJNAAM', 'ProjNaam']

function readFirstTagValue(projectElement, tagNames) {
  for (const tagName of tagNames) {
    const elements = projectElement.getElementsByTagName(tagName)
    if (elements.length && elements[0].textContent) {
      return elements[0].textContent.trim()
    }
  }
  return ''
}

function parseXml(datasetContent) {
  if (!datasetContent || typeof datasetContent !== 'string') return null

  const document = new DOMParser().parseFromString(datasetContent, 'application/xml')

  if (document.getElementsByTagName('parsererror').length) return null

  return document
}

function parseProjects(datasetContent) {
  const document = parseXml(datasetContent)
  if (!document) return []

  const projectElements = Array.from(document.getElementsByTagName(PROJECT_ELEMENT))

  return projectElements
    .map(projectElement => ({
      projectCode: readFirstTagValue(projectElement, CODE_ELEMENTS),
      projectName: readFirstTagValue(projectElement, NAME_ELEMENTS)
    }))
    .filter(project => project.projectCode)
}

export default {
  parseProjects
}
